import { create } from "zustand";

interface AppReadyState {
  /** True once boot warming is done (or the safety timeout fired). */
  appReady: boolean;
  setAppReady: (ready: boolean) => void;
}

export const useAppReadyStore = create<AppReadyState>((set) => ({
  appReady: false,
  setAppReady: (ready) => set({ appReady: ready }),
}));
